// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/create_shotlist_preset.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionShotlistPreset, VisionShotlistPresetCategory } from "./vision_shotlist_preset_pb";
import { file_vision_shotlist_v1_vision_shotlist_preset } from "./vision_shotlist_preset_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/create_shotlist_preset.proto.
 */
export const file_vision_shotlist_v1_create_shotlist_preset: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vc2hvdGxpc3QvdjEvY3JlYXRlX3Nob3RsaXN0X3ByZXNldC5wcm90bxIZcHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MSLkAQobQ3JlYXRlU2hvdGxpc3RQcmVzZXRSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuQ3JlYXRlU2hvdGxpc3RQcmVzZXRSZXF1ZXN0LlBhcmFtcxp2CgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRJJCghjYXRlZ29yeRgCIAEoDjI3LnByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEuVmlzaW9uU2hvdGxpc3RQcmVzZXRDYXRlZ29yeRINCgV2YWx1ZRgDIAEoCSKFAgocQ3JlYXRlU2hvdGxpc3RQcmVzZXRSZXNwb25zZRJOCgZyZXN1bHQYASABKAsyPi5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLkNyZWF0ZVNob3RsaXN0UHJlc2V0UmVzcG9uc2UuUmVzdWx0GpQBCgZSZXN1bHQSSQoIY2F0ZWdvcnkYASABKA4yNy5wcm90b3MudmlzaW9uLnNob3RsaXN0LnYxLlZpc2lvblNob3RsaXN0UHJlc2V0Q2F0ZWdvcnkSPwoGcHJlc2V0GAIgASgLMi8ucHJvdG9zLnZpc2lvbi5zaG90bGlzdC52MS5WaXNpb25TaG90bGlzdFByZXNldGIGcHJvdG8z", [file_vision_shotlist_v1_vision_shotlist_preset]);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotlistPresetRequest
 */
export type CreateShotlistPresetRequest = Message<"protos.vision.shotlist.v1.CreateShotlistPresetRequest"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreateShotlistPresetRequest.Params params = 1;
   */
  params?: CreateShotlistPresetRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotlistPresetRequest.
 * Use `create(CreateShotlistPresetRequestSchema)` to create a new message.
 */
export const CreateShotlistPresetRequestSchema: GenMessage<CreateShotlistPresetRequest> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shotlist_preset, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotlistPresetRequest.Params
 */
export type CreateShotlistPresetRequest_Params = Message<"protos.vision.shotlist.v1.CreateShotlistPresetRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistPresetCategory category = 2;
   */
  category: VisionShotlistPresetCategory;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotlistPresetRequest.Params.
 * Use `create(CreateShotlistPresetRequest_ParamsSchema)` to create a new message.
 */
export const CreateShotlistPresetRequest_ParamsSchema: GenMessage<CreateShotlistPresetRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shotlist_preset, 0, 0);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotlistPresetResponse
 */
export type CreateShotlistPresetResponse = Message<"protos.vision.shotlist.v1.CreateShotlistPresetResponse"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.CreateShotlistPresetResponse.Result result = 1;
   */
  result?: CreateShotlistPresetResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotlistPresetResponse.
 * Use `create(CreateShotlistPresetResponseSchema)` to create a new message.
 */
export const CreateShotlistPresetResponseSchema: GenMessage<CreateShotlistPresetResponse> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shotlist_preset, 1);

/**
 * @generated from message protos.vision.shotlist.v1.CreateShotlistPresetResponse.Result
 */
export type CreateShotlistPresetResponse_Result = Message<"protos.vision.shotlist.v1.CreateShotlistPresetResponse.Result"> & {
  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistPresetCategory category = 1;
   */
  category: VisionShotlistPresetCategory;

  /**
   * @generated from field: protos.vision.shotlist.v1.VisionShotlistPreset preset = 2;
   */
  preset?: VisionShotlistPreset | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.CreateShotlistPresetResponse.Result.
 * Use `create(CreateShotlistPresetResponse_ResultSchema)` to create a new message.
 */
export const CreateShotlistPresetResponse_ResultSchema: GenMessage<CreateShotlistPresetResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_create_shotlist_preset, 1, 0);

